import { createSlice } from '@reduxjs/toolkit';
import { TPlatform } from 'shared/types/platform';

const platformSlice = createSlice({
  initialState: 'other' as TPlatform,
  name: 'platform',
  reducers: {},
});

export const { reducer: platformReducer } = platformSlice;
